module.exports = __webpack_public_path__ + "img/8.ceedfd16.jpg";